import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { InfoChipColor, InfoChipType } from '../info-chip/info-chip.types';
import { MUNILY_NESTED_RESOURCE_CARD_DEFAULTS, MunilyNestedResourceCardData } from './nested-resource-card.types';

@Component({
  selector: 'common-nested-resource-card',
  templateUrl: './nested-resource-card.component.html',
  styleUrls: ['./nested-resource-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NestedResourceCardComponent {
  @Input() data!: MunilyNestedResourceCardData;
  @Output() select = new EventEmitter<void>();

  get ariaLabel(): string {
    return this.data?.ariaLabel || this.data?.title || 'Nested resource';
  }

  get showPrice(): boolean {
    return this.data?.showPrice ?? MUNILY_NESTED_RESOURCE_CARD_DEFAULTS.showPrice;
  }

  get priceLabel(): string {
    return this.data?.priceLabel ?? '';
  }

  /** Layout con encabezado + moneda + importe (cuando el padre envía `priceAmount`). */
  get useSplitPriceLayout(): boolean {
    return this.data != null && this.data.priceAmount !== undefined && this.data.priceAmount !== null;
  }

  get priceHeading(): string {
    return this.data?.priceHeading ?? '';
  }

  get currencySymbol(): string {
    return String(this.data?.currencySymbol ?? '').trim();
  }

  get priceAmount(): string {
    return String(this.data?.priceAmount ?? '').trim();
  }

  get priceUnitLabel(): string {
    return String(this.data?.priceUnitLabel ?? '').trim();
  }

  get chipLabel(): string {
    return this.data?.status?.label ?? '';
  }

  get chipColor(): InfoChipColor {
    return this.data?.status?.color ?? 'green';
  }

  get chipType(): InfoChipType {
    return this.data?.status?.type ?? 'outline';
  }

  onSelect(): void {
    this.select.emit();
  }
}

